var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCopyIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.3337 13.334L15.0003 13.334C15.4424 13.334 15.8663 13.1584 16.1788 12.8458C16.4914 12.5333 16.667 12.1093 16.667 11.6673L16.667 5.00065C16.667 4.55862 16.4914 4.1347 16.1788 3.82214C15.8663 3.50958 15.4424 3.33398 15.0003 3.33398L8.33366 3.33398C7.89163 3.33398 7.46771 3.50958 7.15515 3.82214C6.84259 4.1347 6.66699 4.55862 6.66699 5.00065L6.66699 6.66732M11.667 6.66732C12.109 6.66732 12.5329 6.84291 12.8455 7.15547C13.1581 7.46803 13.3337 7.89196 13.3337 8.33398L13.3337 15.0007C13.3337 15.4427 13.1581 15.8666 12.8455 16.1792C12.5329 16.4917 12.109 16.6673 11.667 16.6673L5.00033 16.6673C4.5583 16.6673 4.13437 16.4917 3.82181 16.1792C3.50925 15.8666 3.33366 15.4427 3.33366 15.0007L3.33366 8.33398C3.33366 7.89196 3.50925 7.46803 3.82181 7.15547C4.13438 6.84291 4.5583 6.66732 5.00033 6.66732L11.667 6.66732Z",
    stroke: "#C7C7C7",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCopyIcon);
export default __webpack_public_path__ + "static/media/copyIcon.4dc520b68508d4d6e53300ac5c4c94dc.svg";
export { ForwardRef as ReactComponent };